'use client'

import {
  inputBase,
  inputDisabled,
  inputError,
  inputFocus,
  inputOutlined,
} from '@/core/constants/class-names'
import { cn } from '@/core/lib/utils/cn'
import { Eye, EyeOff } from 'lucide-react'
import { useState } from 'react'
import { createInput } from './input-factory'

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string | boolean
  errorMessage?: string
}

const BaseInput: React.FC<InputProps> = ({
  className = '',
  error,
  errorMessage,
  type,
  ...rest
}) => {
  const hasError = Boolean(error)
  const [showPassword, setShowPassword] = useState(false)

  const isPassword = type === 'password'
  const inputType = isPassword && showPassword ? 'text' : type

  return (
    <div className='flex w-full flex-col gap-1'>
      <div className='relative w-full'>
        <input
          {...rest}
          type={inputType}
          className={cn(
            'text-navy px-4',
            isPassword && 'pe-10',
            inputBase,
            inputOutlined,
            inputDisabled,
            inputFocus,
            hasError && inputError,
            className,
          )}
        />
        {isPassword && (
          <button
            type='button'
            className='text-grey hover:text-gray-60 absolute top-1/2 right-3 -translate-y-1/2 cursor-pointer'
            onClick={() => setShowPassword(prev => !prev)}
          >
            {showPassword ? <EyeOff /> : <Eye />}
          </button>
        )}
      </div>
      {hasError && errorMessage && (
        <p className='text-red text-sm'>{errorMessage}</p>
      )}
    </div>
  )
}

export const Input = createInput(BaseInput, ['label'])
export const FormInput = createInput(BaseInput, ['form', 'label'])
